module.exports = __webpack_public_path__ + "media/images/flags/32/Hong-Kong-39fa2934fd5275c06b2eb89d8ab2a84b.png";